import {
  ROOT,
  GET_HOTEL_IMAGES,
  UPDATE_HOTEL_IMAGE
} from "@/_helpers/constant.js";

import { requestOptions, handleResponse } from "@/_helpers";

function get() {
  return fetch(ROOT + GET_HOTEL_IMAGES, requestOptions.get())
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function update(data) {
  return fetch(ROOT + UPDATE_HOTEL_IMAGE, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

export const service = {
  get,
  update
};
